define([
	"dojo/_base/declare",
	"dijit/form/DateTextBox",
	"./_DateTimeMixin",
	"./_ErrorMessageMixin"
], function(declare,DateTextBox,_DateTimeMixin,_ErrorMessageMixin) {

	return declare([DateTextBox, _DateTimeMixin, _ErrorMessageMixin], {
		_popupClickEvent: "_onDayClick",

		isDisabledValue: function(/*Date*/dt) {
			// summary: override to set logic for disabling values
			return false;
		},

		rangeCheck: function(/*Date*/dt, /*dijit/form/RangeBoundTextBox.__Constraints*/constraints) {
			// summary: override range check to allow more than just min/max constraints
			var day = dt.getDay(); // 0 is Sunday ... 6 is Saturday
			var ck = this.inherited(arguments) && !this.isDisabledValue(dt);

			if (constraints.workingDaysPerWeek) {
				ck = ck &&
					(day == 0 && constraints.workingDaysPerWeek.includes("Wbs.WorkingDaysPerWeek:Sunday")    ||
					 day == 1 && constraints.workingDaysPerWeek.includes("Wbs.WorkingDaysPerWeek:Monday")    ||
					 day == 2 && constraints.workingDaysPerWeek.includes("Wbs.WorkingDaysPerWeek:Tuesday")   ||
					 day == 3 && constraints.workingDaysPerWeek.includes("Wbs.WorkingDaysPerWeek:Wednesday") ||
					 day == 4 && constraints.workingDaysPerWeek.includes("Wbs.WorkingDaysPerWeek:Thursday")  ||
					 day == 5 && constraints.workingDaysPerWeek.includes("Wbs.WorkingDaysPerWeek:Friday")    ||
					 day == 6 && constraints.workingDaysPerWeek.includes("Wbs.WorkingDaysPerWeek:Saturday"));
			}

			if (constraints.holidays) {
			    var date = new Date(dt);
			    date.setHours(0,0,0,0);
			    ck = ck && !constraints.holidays.includes(date.getTime());
			}
			return ck;
		},

		_getValueAttr: function() {
			// summary: return value in milliseconds
			var	dt = this.inherited(arguments);
			if (dt) dt.setHours(0,0,0,0);
			return dt;
		},

		/**
		 * Set date value; overridden to support time value passed as a number
		 * @param {Date|number} value
		 * @param {boolean} [priorityChange]
		 * @param {string} [formattedValue]
		 */
		_setValueAttr: function(value, priorityChange, formattedValue) {
			this.inherited(arguments, [this.normalizeValue(value), priorityChange, formattedValue]);
		}
	});
});